// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './request'
import store from './vuex/store'
import preventReClick from './common'
import App from './App';
import router from './router';
import Router from 'vue-router'
import './style/util.less'
import modal from './utils/model'
import echarts from "echarts";
import VueAMap from 'vue2-amap';

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.ENVIRONMENTE =  process.env.ENVIRONMENTE
Vue.prototype.baseURL = process.env.API_ROOT
Vue.prototype.baseURL2 = process.env.API_ROOT_AD || process.env.BANNED_API
Vue.prototype.antdiyURL = process.env.ANTDIY_API_ROOT
Vue.prototype.adminURL = process.env.ADMIN_API
Vue.prototype.antdiyLink = process.env.ANTDIY_LINK
Vue.prototype.asLink = process.env.AS_LINK
Vue.prototype.projectURL = process.env.PROJECT_API
Vue.prototype.pointURL = process.env.POINTS_API
Vue.prototype.editionURL = process.env.EDITION_API
Vue.prototype.bannedURL = process.env.BANNED_API
Vue.prototype.automationURL = process.env.AUTOMATION_API
Vue.prototype.crmURL = process.env.CRM_ROOT
Vue.prototype.fbURL = process.env.FB_API
Vue.prototype.mktURL = process.env.MKT_API
Vue.config.productionTip = false
Vue.prototype.sourceServiceUrl = process.env.SOURCE_SERVICE_URL
Vue.prototype.localSourceServiceUrl = process.env.LOCAL_SOURCE_SERVICE_URL
Vue.prototype.PRODUCT_MANAGE_API = process.env.PRODUCT_MANAGE_API
Vue.prototype.COD_PRODUCT_MANAGE_API = process.env.COD_PRODUCT_MANAGE_API
Vue.prototype.$echarts = echarts;
// 模态框对象
Vue.prototype.$modal = modal
Vue.use(ElementUI);
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
    key: 'fe24dbb114722f082d546b25e38d0059', // 替换为你的有效密钥
    plugin: [
        'AMap.Scale', 
        'AMap.OverView', 
        'AMap.ToolBar', 
        'AMap.MapType',
        'AMap.Geocoder' // 关键：添加地理编码插件
    ],
    v: '2.0' // 指定 API 版本
});

let setPower = function(list, url, routerUrl) {
    let isSure = false
    for (let i = 0; i < list.length; i++) {
        if ((routerUrl && list[i].route == routerUrl) || !routerUrl) {
            if (list[i].route == url) {
                isSure = true
                break
            } else if (list[i].children && list[i].children.length) {
                isSure = setPower(list[i].children, url)
                if (isSure == true) {
                    break
                }
            }
        }
    }
    return isSure
}

Vue.prototype.$getPower = function(arr, routerUrl) {
    // if (localStorage.getItem('root_id') == '0') {
    //     return arr.map(str => {
    //         return true
    //     })
    // }
    let menuList = localStorage.getItem('menuList') ? JSON.parse(localStorage.getItem('menuList')) : []
    if (menuList.length) {
        return arr.map(str => {
            return setPower(menuList, str, routerUrl)
        })
    } else {
        return arr.map(str => {
            return false
        })
    }
}

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}

function findMenuName(list, path) {
    const target = (path || '').replace(/^\//, '')
    for (let i = 0; i < list.length; i++) {
        const route = (list[i].route || '').replace(/^\//, '')
        if (route && route === target && list[i].name) {
            return list[i].name
        }
        if (list[i].children && list[i].children.length) {
            const name = findMenuName(list[i].children, path)
            if (name) return name
        }
    }
    return null
}

router.beforeEach((to, from, next) => {
    let cookie = getCookie('Authorization')
    let token = cookie || localStorage.getItem("token")
    if (token || to.path === '/') {
        if (to.path === '/') {
            document.title = '登录'
        } else if (to.meta && to.meta.title) {
            document.title = to.meta.title
        } else {
            const menuList = localStorage.getItem('menuList') ? JSON.parse(localStorage.getItem('menuList')) : []
            document.title = findMenuName(menuList, to.path) || 'admin'
        }
        next()
    } else {
        ElementUI.Message.error('登录信息已过期')
        next({
            path: '/',
        })
    }
})

var vue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
export default vue
